import { ADs, FIXED_AD_ID } from '../components/common/FixedAD';
import { replaceEmptyAd, setEmptyAdID } from '../store/modules/replaceEmptyAd';

export const handleEmptyAd = (store) => (next) => (action) => {
  if (action.type === replaceEmptyAd.type) {
    let ads = null;
    if (store.getState().popup.fileMenu.isShow === true) {
      ads = ADs.filter((ad) => ad.id === FIXED_AD_ID.IN_FILEMENU);
    } else {
      const dialogType = store.getState().dialog.dialogType;
      ads = ADs.filter((ad) => ad.parent === dialogType);
    }
    if (ads) {
      store.dispatch(setEmptyAdID(ads.map((ad) => ad.id)));
    }
  }
  return next(action);
};
